// extracted by mini-css-extract-plugin
export default {"DeleteClassificationsDialog":"DeleteClassificationsDialog_DeleteClassificationsDialog__BdWO3"};